var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutostaking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_996_18419)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.800018,
    width: 16,
    height: 16,
    fill: "#1BBB82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9517 9.66667C12.5616 9.42415 13.8 8.03612 13.8 6.35397C13.8 4.50155 12.2985 3 10.446 3C8.7639 3 7.37587 4.23839 7.13335 5.8483H7.14883C9.16638 6.00826 10.7918 7.63364 10.9517 9.63571V9.66667ZM7.40002 6.34359C9.02566 6.4718 10.3282 7.77436 10.4564 9.4C10.4616 9.48718 10.4667 9.57949 10.4667 9.66667C10.4667 11.5077 8.97438 13 7.13335 13C5.29233 13 3.80002 11.5077 3.80002 9.66667C3.80002 7.82564 5.29233 6.33333 7.13335 6.33333C7.22053 6.33333 7.31284 6.33846 7.40002 6.34359ZM7.13335 10.9487L7.58463 10.1179L8.4154 9.66667L7.58463 9.21538L7.13335 8.38462L6.68207 9.21538L5.8513 9.66667L6.68207 10.1179L7.13335 10.9487Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_996_18419"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.800018,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutostaking);
export default __webpack_public_path__ + "static/media/autostaking.3f388ce32761216cff0089c55d1600b6.svg";
export { ForwardRef as ReactComponent };